import React from 'react'
import { Link } from 'react-router-dom';

export default function HeaderTitle({ title }) {
  return (
      <header className="lg:h-56 h-40 gradient-bg w-full wrapper flex items-start flex-col justify-center">
      <h3 className="xl:text-5xl md:text-3xl text-2xl font-fira font-semibold mb-3">{ title }</h3>
      <div className="flex justify-start items-center">
          <span>
              <Link to="/" className="font-semibold text-blue-900 text-xm mr-3">Home</Link>
          </span>
          <span className="mr-3">
              /
          </span>
          <span>
              { title }
          </span>
      </div>
    </header>
  )
}
